<template>
  <RecordingModal />
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7 area-cam-map">
    <div class="cam-map-content ps-3 pe-3 pb-1 pt-4">
      <h5 class="card-title fw-bold mb-15 mb-sm-20 mb-md-25">Mapa de câmeras</h5>
      <div class="row">
        <div id="map" class="radius-7"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { defineComponent } from "vue";
import L from "leaflet";
import { Modal } from "bootstrap";
import RecordingModal from '../Recordings/RecordingModal.vue';
import defaultCameraThumbnail from '../../assets/images/camera-placeholder.svg';

export default defineComponent({
  name: "CamMap",
  data() {
    return {
      map: null,
      modalKey: 0,
      cameras: [
        { lat: -23.55052, lon: -46.633308, name: "Câmera 1" },
        { lat: -22.9068, lon: -43.1729, name: "Câmera 2" },
      ],
    };
  },
  components: {
    RecordingModal
  },
  mounted() {
    this.setCamerasForClient().then(() => {
      this.initMap();
    });
  },
  beforeUnmount() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },
  computed:{
    ...mapGetters([
      'getCamerasForClient'
    ])
  },
  methods: {
    ...mapActions([
        "setCamerasForClient",
        "setRecordingShowModalState",
        "setCurrentRecording"
    ]),
    setRecordingOnModal(currentRecording){
      this.setRecordingShowModalState(true);

      this.modalKey++;
      currentRecording.key = this.modalKey;

      this.setCurrentRecording([currentRecording]);
    },
    initMap() {
      this.map = L.map("map", { zoomAnimation: false }).setView([-23.55052, -46.633308], 10);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(this.map);

      this.getCamerasForClient.forEach((camera) => {
    if (camera.address != null) {
        const cameraThumbnail = camera.thumbnail || defaultCameraThumbnail;

        // Criar o marcador
        const marker = L.marker([camera.address.latitude, camera.address.longitude])
            .addTo(this.map)
            .bindPopup(`
                <div class="mb-2">
                  <span>
                    <img alt="Camera" width="200" class="radius-7 img-table-camera w-100 mb-2" src="${cameraThumbnail}" onerror="this.onerror=null;this.src='${defaultCameraThumbnail}'" /></br>
                  </span>
                  <span>
                    <strong>Proprietário: </strong>${camera.name} (${camera.company_name})</br>
                  </span>
                  <span>
                    <strong>Endereço: </strong>${camera.address.street}, ${camera.address.number} - ${camera.address.zip_code}</br>
                  </span>
                </div>
                <button id="btn-${camera.id}" class="open-modal-button btn btn-sm btn-success w-100">Ver Ao Vivo</button>
            `);

        // Evento para quando o popup abrir
        marker.on("popupopen", () => {
            this.$nextTick(() => {

                const button = document.getElementById(`btn-${camera.id}`);
                if (button) {
                  button.addEventListener("click", () => {

                        this.setRecordingOnModal(camera);

                        // Abre o modal manualmente
                        const modalElement = document.getElementById("RecordingModal");
                        if (modalElement) {
                            const modalInstance = new Modal(modalElement);
                            modalInstance.show();
                        }
                    });
                }
            });
        });
    }
});



    },
  },
});
</script>

<style scoped>
#map {
  height: calc(100vh - 298px);
  height: calc(100dvh - 298px);
  min-height: 500px;
  width: 100%;
}

@media (max-width: 767px) {
  .area-cam-map {
    margin-right: -15px;
    margin-bottom: 0 !important;
    margin-left: -15px;
    border-radius: 0 !important;
  }

  .cam-map-content {
    padding-right: 8px !important;
    padding-left: 8px !important;
  }

  .cam-map-content .row {
    margin-right: 0;
    margin-left: 0;
  }

  #map {
    height: calc(100vh - 131px);
    height: calc(100dvh - 131px);
    min-height: 400px;
    padding-right: 0;
    padding-left: 0;
  }
}
</style>
